/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trim_To_DurationInputs */



/**
* | output |
* | --- |
* | "Trim to Duration" |
*
* @param {Trim_To_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const trim_to_duration = /** @type {((inputs?: Trim_To_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trim_To_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajuster à la durée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf Dauer kürzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ritaglia in base alla durata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обрезать до длительности")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recortar a duración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修剪至时长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("継続時間に合わせてトリム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवधि के अनुसार ट्रिम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajustar à duração")
	return /** @type {LocalizedString} */ ("Trim to Duration")
});